/**
 * Sticky Buy Bar — clean product-page sticky bar.
 * Contains: Product Image | Title | Price | Buy Now Button
 * Features: AJAX checkout, variant & price sync, scroll-triggered visibility.
 */
(function () {
  'use strict';

  function init() {
    if (window.innerWidth >= 769) return;

    var card = document.getElementById('sticky-buy-card');
    if (!card || card.getAttribute('data-sbb-init') === 'true') return;
    card.setAttribute('data-sbb-init', 'true');

    var form = document.getElementById('sticky-card-form');
    var buyBtn = document.getElementById('sticky-card-buy-btn');
    var buyLabel = buyBtn ? buyBtn.querySelector('.sb-btn-label') : null;
    var variantInput = document.getElementById('sticky-card-variant-input');
    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var purchasePending = false;

    /* Liquid resolves the label (a pre-order metafield may carry custom wording that the
       main Add to Cart button also uses), so read it back rather than re-deriving it. */
    function activeLabel() {
      if (!buyBtn) return 'BUY NOW';
      return buyBtn.getAttribute('data-active-label')
        || (buyBtn.getAttribute('data-is-preorder') === 'true' ? 'PRE-ORDER' : 'BUY NOW');
    }

    /* ---------- Bar Height ---------- */
    /* The bar is permanently visible (the stylesheet pins it to the bottom with
       !important), so there is no show/hide state to track. What it does need is to
       publish its real height, which the stylesheet uses to pad the footer out from
       under it. */
    function publishBarHeight() {
      if (window.innerWidth >= 769) return;
      var h = card.offsetHeight;
      if (h > 0) document.body.style.setProperty('--sbb-height', h + 'px');
    }

    publishBarHeight();
    window.addEventListener('resize', publishBarHeight);
    window.addEventListener('orientationchange', publishBarHeight);

    /* ---------- Main Product Form ---------- */
    /* The sticky bar has its own form that also posts to /cart/add, so every lookup has
       to skip it explicitly or it reads back its own page-load values instead of what
       the customer actually picked. */
    function getMainProductForm() {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i] !== form && forms[i].id !== 'sticky-card-form') return forms[i];
      }
      return null;
    }

    /* ---------- Current Variant ID Detection ---------- */
    function getCurrentVariantId() {
      /* The main form's id input is the same value the main Add to Cart button posts:
         theme.js re-enables it on connect and rewrites it on every variant change. Read
         it first so the two buttons can never disagree; the URL is only a fallback for
         when the form has not been found yet. */
      var mainForm = getMainProductForm();
      var f = mainForm && (mainForm.querySelector('input[name="id"]') || mainForm.querySelector('select[name="id"]'));
      if (f && f.value) return f.value;

      try {
        var p = new URLSearchParams(window.location.search);
        if (p.get('variant')) return p.get('variant');
      } catch (e) {}

      return variantInput ? variantInput.value : '';
    }

    /* ---------- Current Quantity ---------- */
    function getCurrentQuantity() {
      /* The product page quantity selector lives outside the form element and is tied to
         it with a form="" attribute, so it is reachable through form.elements. */
      var mainForm = getMainProductForm();
      var input = mainForm && mainForm.elements ? mainForm.elements.namedItem('quantity') : null;
      /* namedItem returns a RadioNodeList if anything else in the form shares the name;
         a real element has a tagName, the list does not. */
      if (input && !input.tagName && input.length) input = input[0];

      var qty = input ? parseInt(input.value, 10) : NaN;
      if (!qty || isNaN(qty) || qty < 1) qty = 1;
      return qty;
    }

    /* ---------- Dynamic Variant Sync ---------- */
    function syncDisplayedInfo() {
      if (purchasePending) return;
      var vid = getCurrentVariantId();
      if (vid && variantInput && variantInput.value !== vid) {
        variantInput.value = vid;
      }
      var mainSubmitBtn = document.querySelector('.product-info buy-buttons button[type="submit"]');
      if (mainSubmitBtn && mainSubmitBtn.disabled) {
        if (buyBtn) {
          buyBtn.disabled = true;
          if (buyLabel) buyLabel.textContent = 'SOLD OUT';
        }
      } else if (mainSubmitBtn && !mainSubmitBtn.disabled) {
        if (buyBtn) {
          buyBtn.disabled = false;
          if (buyLabel) buyLabel.textContent = activeLabel();
        }
      }
    }

    /* ---------- AJAX Buy Now Action ---------- */
    function addViaAjax(vid, qty) {
      var body = new FormData();
      body.append('id', vid);
      body.append('quantity', String(qty));

      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        body: body,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || (data && data.status && data.status >= 400)) {
              alert((data && (data.description || data.message) || 'Could not add this item to cart.').split('(')[0].trim());
              return false;
            }
            window.location.href = ROOT + 'checkout';
            return true;
          });
        })
        .catch(function () {
          if (form) form.submit();
          return false;
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (purchasePending || (buyBtn && buyBtn.disabled)) return;
        var vid = getCurrentVariantId();
        if (!vid) { alert('Please select a product option.'); return; }
        var qty = getCurrentQuantity();

        /* The catch() branch below falls back to a native submit of this form, so its
           hidden inputs have to carry the same values the AJAX call is about to use. */
        if (variantInput) variantInput.value = vid;
        var stickyQtyInput = form.querySelector('input[name="quantity"]');
        if (stickyQtyInput) stickyQtyInput.value = qty;

        purchasePending = true;
        if (buyBtn) {
          buyBtn.disabled = true;
          buyBtn.classList.add('is-loading');
        }

        addViaAjax(vid, qty).then(function (ok) {
          if (!ok) {
            purchasePending = false;
            if (buyBtn) buyBtn.classList.remove('is-loading');
            syncDisplayedInfo();
          }
        });
      });
    }

    /* ---------- Dynamic Floating Widget Positioning on Mobile ---------- */
    function adjustFloatingWidgets() {
      if (window.innerWidth >= 769) return;

      var isProduct = document.body.classList.contains('template-product');

      // 1. WhatsApp Button
      var waEls = document.querySelectorAll('.whatsapp-float-btn');
      for (var w = 0; w < waEls.length; w++) {
        if (isProduct) {
          waEls[w].style.setProperty('bottom', 'calc(112px + env(safe-area-inset-bottom, 0px))', 'important');
          waEls[w].style.setProperty('right', '12px', 'important');
        } else {
          waEls[w].style.setProperty('bottom', 'calc(10px + env(safe-area-inset-bottom, 0px))', 'important');
          waEls[w].style.setProperty('right', '12px', 'important');
        }
        waEls[w].style.setProperty('left', 'auto', 'important');
        waEls[w].style.setProperty('width', '42px', 'important');
        waEls[w].style.setProperty('height', '42px', 'important');
        waEls[w].style.setProperty('z-index', '99999', 'important');
      }

      var waImgs = document.querySelectorAll('.whatsapp-float-btn__img');
      for (var wi = 0; wi < waImgs.length; wi++) {
        waImgs[wi].style.setProperty('width', '42px', 'important');
        waImgs[wi].style.setProperty('height', '42px', 'important');
      }

      // 2. Currency Switcher
      var curEls = document.querySelectorAll('div.doubly-float, .doubly-float, .doubly-wrapper, #doubly-float');
      for (var c = 0; c < curEls.length; c++) {
        if (isProduct) {
          curEls[c].style.setProperty('bottom', 'calc(62px + env(safe-area-inset-bottom, 0px))', 'important');
        } else {
          curEls[c].style.setProperty('bottom', 'calc(10px + env(safe-area-inset-bottom, 0px))', 'important');
        }
        curEls[c].style.setProperty('left', '10px', 'important');
        curEls[c].style.setProperty('right', 'auto', 'important');
        curEls[c].style.setProperty('transform', 'scale(0.85)', 'important');
        curEls[c].style.setProperty('transform-origin', 'bottom left', 'important');
      }

      // 3. Try-On (Aabhas VTO) Floating Launcher (Product Page only)
      if (isProduct) {
        var bodyChildren = document.body.children;
        for (var b = 0; b < bodyChildren.length; b++) {
          var el = bodyChildren[b];
          if (!el || el.id === 'sticky-buy-card' || el.tagName === 'MAIN' || el.tagName === 'HEADER' || el.tagName === 'FOOTER') continue;
          if (el.classList.contains('whatsapp-float-btn') || el.classList.contains('doubly-float') || el.classList.contains('doubly-wrapper')) continue;
          var style = window.getComputedStyle(el);
          if (style.position === 'fixed') {
            var idClass = ((el.id || '') + ' ' + (el.className || '')).toLowerCase();
            if (idClass.indexOf('aabhas') !== -1 || idClass.indexOf('vto') !== -1 || idClass.indexOf('tryon') !== -1 || idClass.indexOf('try-on') !== -1) {
              /* The launcher is injected by the app, so it cannot be named in a static
                 stylesheet. Tag it instead: theme.css hides `.sbb-floating-widget` while
                 `html.lock` is set, which is what keeps it from painting over an open
                 drawer or modal. */
              el.classList.add('sbb-floating-widget');
              el.style.setProperty('bottom', 'calc(62px + env(safe-area-inset-bottom, 0px))', 'important');
              el.style.setProperty('right', '12px', 'important');
              el.style.setProperty('left', 'auto', 'important');
              el.style.setProperty('transform', 'scale(0.75)', 'important');
              el.style.setProperty('transform-origin', 'bottom right', 'important');
            }
          }
        }
      }
    }

    /* ---------- Watchers & Initializers ---------- */
    syncDisplayedInfo();
    adjustFloatingWidgets();

    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || (e.target.closest && e.target.closest('variant-picker')))) {
        setTimeout(syncDisplayedInfo, 80);
      }
    });

    document.addEventListener('variant:change', function () {
      setTimeout(syncDisplayedInfo, 50);
    });

    /* Fallback retries for slow rendering / app injected elements */
    var count = 0;
    var timer = setInterval(function () {
      count++;
      syncDisplayedInfo();
      adjustFloatingWidgets();
      if (count > 20) clearInterval(timer);
    }, 250);

    window.addEventListener('load', function () {
      syncDisplayedInfo();
      adjustFloatingWidgets();
      publishBarHeight();
    });

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      purchasePending = false;
      if (buyBtn) buyBtn.classList.remove('is-loading');
      syncDisplayedInfo();
      publishBarHeight();
    });

    if ('MutationObserver' in window) {
      /* This watches the whole body subtree, so it fires for every card image swap,
         section re-render and drawer open on the page. adjustFloatingWidgets() reads
         getComputedStyle for each body child, so running it per mutation is expensive
         for no benefit — coalesce a burst into one call on the next frame. */
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          adjustFloatingWidgets();
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
